module.exports = __webpack_public_path__ + "img/yidaiyilu-1@3x.75379337.png";